import fetchApi from "../fetchApi";

export const CreateSellSpecialtyItem = async (data) => {
  const options = {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(data),
    redirect: "follow",
  };

  return await fetchApi("card-issuing/specialty-items", options);
};
